import { generateClient } from "aws-amplify/api";
import { recordSentry } from "./recordSentry";

const query = /* GraphQL */ `
	query ConfirmFieldInstanceMissing($id: ID!) {
		getFieldInstance(id: $id) {
			id
		}
	}
`;

/**
 * Asks the cloud directly whether a field instance exists. Used before a repair recreates an alt instance under an
 * existing id: a nested `altInstance` that came back empty usually means the document is missing, but it can also mean
 * it could not be read, and recreating it would overwrite it. Only a clean "not found" answers true.
 * @param id The field instance id
 * @returns True only when the cloud reports no document and no error for that id
 */
export async function confirmFieldInstanceMissing(id: string): Promise<boolean> {
	try {
		const client = generateClient({ authMode: "userPool" });
		const response = (await client.graphql({ query, variables: { id }, authMode: "userPool" })) as {
			data?: { getFieldInstance: { id: string } | null };
			errors?: unknown[];
		};
		if (response.errors?.length) return false;
		return response.data?.getFieldInstance === null;
	} catch (error) {
		recordSentry({ error, msg: "Could not confirm whether a field instance is missing", additionalData: { id } });
		return false;
	}
}
